module.exports = __webpack_public_path__ + "static/media/lastest.f70eb8b6.svg";